/**
 * @generated SignedSource<<6268cab9c56bd2e2f5a4e2adaf11d859>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorefrontProductTile_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"FavoritesItemProvider_user">;
  readonly " $fragmentType": "StorefrontProductTile_user";
};
export type StorefrontProductTile_user$key = {
  readonly " $data"?: StorefrontProductTile_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontProductTile_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontProductTile_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItemProvider_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7399e1c279aa46eb035a97ec0284793b";

export default node;
